.ds-footer-navigation {
  display: flex;
  flex-wrap: wrap;
  margin-block: 0 rem(-.9375);
  margin-inline: rem(-.9375);
  padding-inline: 0;
  padding-block: 0;
  border-block-end: 1px solid $white;
  line-height: 2;
  list-style: none;

  @media only screen and (min-width: 769px) {
    justify-content: center;
    margin-block: 0;
    margin-inline: calc(rem(1.125) / -2);
    border-block-end: none;
  }

  &__item {
    width: 50%;
    padding-block: var(--cxs-spacer-s);
    border-block-start: 1px solid $white;
    text-align: center;

    @media only screen and (min-width: 769px) {
      width: auto;
      padding-block: 0;
      padding-inline: calc(rem(1.125) / 2);
      border-block-start: none;
      text-align: inherit;
    }

    &:nth-child(odd) {
      border-inline-end: 1px solid $white;

      @media only screen and (min-width: 769px) {
        border-inline-end: none;
      }
    }

    &:nth-child(even) {
      border-inline-end: none;
    }
  }

  &__link {
    color: var(--footer-item-color);
    font-family: var(--footer-font-family);
    font-size: var(--footer-navigation-item-size);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
